




















import Vue from 'vue';
import JerseyButtonRed from '@/components/elements/JerseyButtonRed.vue';

export default Vue.extend({
  name: 'Start',
  components: { JerseyButtonRed },
});
